import {NavLink} from "react-router";
import clsx from "clsx";
import {resolveTo} from "../utils/menu-utils.js";
import {FaSignOutAlt} from "react-icons/fa";
import MenuIcon from "./menu-icon.jsx";
import MenuBadge from "./menu-badge.jsx";
import useLogout from "../../../hooks/use-logout.js";
import {toggleDevMenu} from "../utils/dev-menu.js";

const SidebarShortcuts = ({shortcuts, badges = {}}) => {
    const logout = useLogout();

    const onLogoutClick = (event) => {
        event.preventDefault();
        logout();
    };

    const onMyUserClick = (event) => {
        if (!event.altKey || !event.shiftKey) return;
        event.preventDefault();
        toggleDevMenu();
    };

    return (
        <section className="mdb-sidebar-shortcuts">
            {shortcuts.map((sm) => {
                if (sm.id === "logout") {
                    return (
                        <a key="logout" id="menu-logout" className="mdb-shortcut-link" href={"#"} onClick={onLogoutClick} title={sm.name}>
                            <FaSignOutAlt className="mdb-menu-icon" />
                        </a>
                    );
                }

                const to = resolveTo(sm.url);
                if (!to) return null;

                const count = badges[sm.id];

                return (
                    <NavLink
                        key={sm.id || sm.name}
                        id={`menu-${sm.id}`}
                        to={to}
                        end={to === "/"}
                        onClick={sm.id === "myUser" ? onMyUserClick : undefined}
                        title={count ? `${sm.name} (${count})` : sm.name}
                        className={({isActive}) => clsx("mdb-shortcut-link", isActive && "active")}
                    >
                        <MenuIcon icon={sm.icon} />
                        <MenuBadge count={count} />
                    </NavLink>
                );
            })}
        </section>
    )
};

export default SidebarShortcuts;
